/**
 * commodity Normalizr Schema
 */

import { schema } from 'normalizr';

import variety from './variety';

const commodity = new schema.Entity('commodities', { varieties: [variety] });

export default commodity;
